class BuildYourBundle extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      itemHtml: '[bucket-item-html]',
      bucketItem: '[bucket-product-item]',
      addToCartBtn: '[add-to-cart]',
      overlay: '[bucket-overlay]',
      bucketToggle: '[bucket-toggle]',
      bucketDrawer: '[bucket-drawer]'
    };
    this.initialize();
  }

  initialize() {
    this.itemTemplate = this.querySelector(this.selectors.itemHtml).innerHTML;
    this.addToCartBtn = this.querySelector(this.selectors.addToCartBtn);
    this.drawer = this.querySelector(this.selectors.bucketDrawer);
    this.toggleBtns = this.querySelectorAll(this.selectors.bucketToggle);
    this.overlay = this.querySelector(this.selectors.overlay);

    this.addToCartBtn?.addEventListener('click', () => { this.addToCart(); });
    this.bucketList = this.querySelector('.bk-list');
    this.refreshPlaceholders();
    this.updateAddToCartState();


    this.toggleBtns?.forEach(toggleBtn => {
      toggleBtn?.addEventListener('click', () => {
        this.handleDrawer();
      });
    });
  }

  handleDrawer() {
    if (!this.drawer || !this.toggleBtns.length || !this.overlay) return;

    const isActive = this.drawer.classList.contains('active');
    const newState = !isActive;

    this.drawer.classList.toggle('active', newState);
    this.overlay.classList.toggle('active', newState);

    // Toggle body overflow
    document.body.style.overflow = newState ? 'hidden' : '';
  }


  handleButtonClick(variant, button) {
    if (!variant) return;

    const qtyInput = button?.parentElement?.querySelector('.quantity__input');
    const qtyToAdd = parseInt(qtyInput?.value || 1, 10);

    // check if variant already exists
    const existingItem = this.bucketList.querySelector(`[data-variant-id="${variant.id}"]`);

    if (existingItem) {
      // update quantity only
      const qtyEl = existingItem.querySelector('[data-qty]');
      const newQty = parseInt(qtyEl.textContent, 10) + qtyToAdd;
      qtyEl.textContent = newQty;
      this.updateBtnStatus(button);
      return;
    }

    // no existing variant → insert into placeholder
    const target = this.bucketList.querySelector('.placeholder--item');
    let wrapper;

    if (target) {
      wrapper = target;
      wrapper.classList.remove('placeholder--item');
    } else {
      wrapper = document.createElement('li');
      wrapper.className = 'bk-list__item w-full h-full';
      this.bucketList.appendChild(wrapper);
    }

    let html = this.itemTemplate.replaceAll('{variant_id}', variant.id).replaceAll('{product_title}', variant.product_title).replaceAll('{variant_title}', variant.title).replaceAll('{variant_price}', variant.price).replaceAll('{img_url}', variant.featured_image).replaceAll('{image_width}', 200).replaceAll('{image_height}', 200).replaceAll('{quantity}', qtyToAdd);

    wrapper.innerHTML = html;

    const removeBtn = wrapper.querySelector('[remove-btn]');
    removeBtn.addEventListener('click', () => this.onRemoveItem(wrapper));

    this.refreshPlaceholders();
    this.updateAddToCartState();
    this.updateBtnStatus(button);

    this.checkDrawerOpen();
  }

  checkDrawerOpen() {
    const quantityToggleEl = this.querySelector('.byb-bucket');
    console.log(quantityToggleEl);

    if (!quantityToggleEl) return;

    const targetQuantity = parseInt(quantityToggleEl.dataset.quantityToggle || 0, 10);
    const productItems = this.querySelectorAll('.bk-prod[data-variant-id]');
    const addedQuantity = productItems.length;

    console.log("=================>>>>>>>>",targetQuantity, addedQuantity);

    if (addedQuantity >= targetQuantity) {
      if (!this.drawer?.classList.contains('active') && window.innerWidth <= 992) {
        this.drawer?.classList.add('active');
        this.overlay?.classList.add('active');
        // document.body.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      }
    }
  }



  updateBtnStatus(button) {
    const originalText = button.textContent;
    button.textContent = 'Added!';
    button.disabled = true;

    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 5000);
  }

  onRemoveItem(item) {
    item.remove();
    this.refreshPlaceholders();
    this.updateAddToCartState();
  }

  refreshPlaceholders() {
    // count current non-placeholder items
    const items = this.bucketList.querySelectorAll('[data-variant-id]');
    const placeholders = this.bucketList.querySelectorAll('.placeholder--item');
    placeholders.forEach(p => p.remove());
    const quantityHolder = this.querySelector('.active[data-quantity-toggle]');
    const activeTab = document.querySelector('.bundle--tab-btn.active');    
    const maxQuantity = parseInt(activeTab?.dataset.quantity || 3, 10);
    const needed = maxQuantity - items.length;


    console.log("==>>>", needed);

    for (let i = 0; i < needed; i++) {
      const li = document.createElement('li');
      li.className = 'bk-list__item w-full h-full placeholder--item';
      li.setAttribute('bucket-product-item', '');
      li.innerHTML = `<div class="bk-prod relative w-full h-full"><p class="absolute top-0 left-0 w-full h-full flex items-center justify-center opacity[0.5]">${items.length + i + 1}</p></div>`;
      this.bucketList.appendChild(li);
    }
  }

  updateAddToCartState() {
    if (!this.addToCartBtn) return;
    const itemsCount = this.bucketList.querySelectorAll('[data-variant-id]').length;
    console.log(itemsCount, "updateAddToCartStateupdateAddToCartStateupdateAddToCartStateupdateAddToCartState")
    if (itemsCount < 2) {
      this.addToCartBtn.disabled = true;
      this.addToCartBtn.classList.add('opacity-50', 'cursor-not-allowed');
    } else {
      this.addToCartBtn.disabled = false;
      this.addToCartBtn.classList.remove('opacity-50', 'cursor-not-allowed');
    }
  }

  addToCart() {
    this.addToCartBtn.classList.add('loading');
    const items = [];
    this.bucketList.querySelectorAll('[data-variant-id]').forEach(item => {
      const variantId = item.getAttribute('data-variant-id');
      const qty = parseInt(item.querySelector('[data-qty]')?.textContent || 1, 10);
      items.push({ id: variantId, quantity: qty });
    });

    if (items.length < 2) {
      alert('Please select at least 2 products before adding to cart.');
      this.addToCartBtn.classList.remove('loading');
      return;
    }

    const discountCode = items.length === 2 ? 'BundleDiscount20' : 'BundleDiscount30';

    // Attach discount code as line item property
    const itemsWithDiscount = items.map(i => ({
      ...i,
      properties: { _discount: discountCode }
    }));

    console.log(discountCode, JSON.stringify({ items: itemsWithDiscount }), itemsWithDiscount);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itemsWithDiscount })
    })
      .then(res => {
        if (!res.ok) return res.json().then(err => Promise.reject(err));
        return res.json();
      })
      .then(data => {
        console.log('Added to cart:', data);
        // Redirect through discount URL so Shopify applies it
        const discountUrl = `${location.origin}/discount/${encodeURIComponent(discountCode)}?redirect=/checkout`;
        window.location.href = discountUrl;
      })
      .catch(() => {
        alert('Something went wrong while adding items to cart. Please try again.');
        this.addToCartBtn.classList.remove('loading');
      });
  }
}

customElements.define('build-your-bundle', BuildYourBundle);





class BundleProductCard extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      optionInput: '[data-variant-option]',
      variantJson: '[data-variants-json]',
      addButton: '[quick-add-btn]',
      image: '[data-product-card-featured-image][data-main-media]'
    };

    this.matchingVariant = null;
    this.init();
  }

  init() {
    this.optionInputs = this.querySelectorAll(this.selectors.optionInput);
    this.variantJsonText = this.querySelector(this.selectors.variantJson);
    this.addButton = this.querySelector(this.selectors.addButton);

    if (this.variantJsonText) { this.variantsJson = JSON.parse(this.variantJsonText.textContent); }

    this.optionInputs.forEach(input => {
      input.addEventListener('change', this.onOptionChange.bind(this));
    });

    this.addButton?.addEventListener('click', () => { this.animateToBucket(this.addButton); this.closest('build-your-bundle')?.handleButtonClick(this.matchingVariant, this.addButton); });
    this.onOptionChange();
  }

  // onOptionChange() {
  //   const selectedValues = Array.from(this.optionInputs).filter(input => input.checked).map(input => input.value);
  //   this.matchingVariant = this.variantsJson.find(variant => variant.options.every(option => selectedValues.includes(option)));
  //   if (this.matchingVariant) { console.log("Variant ID:", this.matchingVariant.id, this.matchingVariant); this.handleVariantChange(); } else { console.log("No matching variant"); }
  // }
  
  onOptionChange() {
    const selectedValues = Array.from(this.optionInputs).filter(input => input.checked).map(input => input.value);
    this.matchingVariant = this.variantsJson.find(variant => variant.options.every(option => selectedValues.includes(option)));

    if (this.matchingVariant) {
      console.log("✅ Variant found:", this.matchingVariant.id, this.matchingVariant);
      this.handleVariantChange();
    } else {
      console.warn("⚠️ Variant not found for options:", selectedValues);
      this.addButton.disabled = true;
      this.addButton.textContent = 'Unavailable';
    }
  }

  handleVariantChange() {
    if (!this.matchingVariant || !this.addButton) return;
    if (this.matchingVariant.available === false) { this.addButton.disabled = true; this.addButton.textContent = 'Sold out'; } else if (this.addButton.disabled === true) { this.addButton.disabled = false; this.addButton.textContent = 'add'; }
    this.addButton.dataset.variantId = this.matchingVariant.id;
    this.handleUpdateMedia();
  }

  handleUpdateMedia() {
    // Get the current image element
    const currentImage = this.querySelector(this.selectors.image);
    if (!currentImage) { console.log('No card image element found'); return; }
    // Create new image element with same classes
    const newImage = document.createElement('img');
    newImage.className = currentImage.className;

    // Generate srcset with different widths
    const widths = [128, 240, 380, 480, 540, 640, 720, 920, 1080, 1768, 2056];
    const srcset = widths
      .map(width => `${this.matchingVariant.featured_image}?width=${width} ${width}w`)
      .join(',');

    newImage.srcset = srcset;
    newImage.src = `${this.matchingVariant.featured_image}`;
    newImage.alt = currentImage.alt;
    newImage.setAttribute('data-product-card-featured-image', '');
    newImage.setAttribute('data-main-media', '');
    newImage.loading = "lazy";

    // Replace old image with new one
    currentImage.replaceWith(newImage);
  }

  animateToBucket(button) {
    const bucketList = document.querySelector('.bk-list');
    const bucketToggle = document.querySelector('.byb-bucket--toggle');
    if (!bucketList || !bucketToggle) return;

    const isMobile = window.innerWidth <= 990;

    let targetElement;
    if (isMobile) {
      targetElement = bucketToggle;
    } else {
      const bucketItems = Array.from(bucketList.querySelectorAll('[bucket-product-item]'));
      const placeholder = bucketItems.find(el => el.classList.contains('placeholder--item'));
      targetElement = placeholder || bucketList.lastElementChild;
    }

    if (!targetElement) return;

    const bubble = document.createElement('div');
    bubble.className = 'bubble-anim';
    document.body.appendChild(bubble);

    const buttonRect = button.getBoundingClientRect();
    const startX = buttonRect.left + buttonRect.width / 2;
    const startY = buttonRect.top + buttonRect.height / 2;
    bubble.style.left = `${startX}px`;
    bubble.style.top = `${startY}px`;

    let endX, endY;
    if (isMobile) {
      const targetRect = targetElement.getBoundingClientRect();
      endX = targetRect.left + targetRect.width / 2;
      endY = targetRect.top + targetRect.height / 2;
    } else {
      const targetRect = targetElement.getBoundingClientRect();
      const cs = getComputedStyle(bucketList);
      const gapPx = parseFloat(cs.gap || cs.columnGap || cs.rowGap) || 0;
      const flexDir = (cs.flexDirection || 'row').toLowerCase();
      const newW = targetRect.width;
      const newH = targetRect.height;

      if (targetElement.classList.contains('placeholder--item')) {
        endX = targetRect.left + targetRect.width / 2;
        endY = targetRect.top + targetRect.height / 2;
      } else {
        if (flexDir.startsWith('row')) {
          endX = targetRect.left + targetRect.width + gapPx + newW / 2;
          endY = targetRect.top + targetRect.height / 2;
        } else {
          endX = targetRect.left + targetRect.width / 2;
          endY = targetRect.top + targetRect.height + gapPx + newH / 2;
        }
      }
    }

    const deltaX = endX - startX;
    const deltaY = endY - startY;
    const lift = Math.min(120, Math.max(30, Math.hypot(deltaX, deltaY) * 0.18));
    const midX = deltaX * 0.5;
    const midY = deltaY * 0.5 - lift;

    const animation = bubble.animate(
      [
        { transform: `translate(0px, 0px) scale(1)`, opacity: 1 },
        { transform: `translate(${midX}px, ${midY}px) scale(0.9)`, opacity: 0.95, offset: 0.45 },
        { transform: `translate(${deltaX}px, ${deltaY}px) scale(0.6)`, opacity: 0.3 }
      ],
      {
        duration: 700,
        easing: 'cubic-bezier(0.25, 0.8, 0.25, 1)',
        fill: 'forwards'
      }
    );

    animation.onfinish = () => bubble.remove();
  }

}
customElements.define('bundle-product-card', BundleProductCard);

class optionElementSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.wrapper = this.querySelector('.scroll--slider');
    this.container = this.querySelector('.prod-opt-values');
    this.prevButton = this.querySelector('button[name="prev"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.shadowLeft = this.querySelector('.slider__shadow--left');
    this.shadowRight = this.querySelector('.slider__shadow--right');

    this.updateUI();
    this.container.addEventListener('scroll', this.updateUI.bind(this));
    window.addEventListener('resize', this.updateUI.bind(this));

    this.prevButton.addEventListener('click', () => this.scrollByItem(-1));
    this.nextButton.addEventListener('click', () => this.scrollByItem(1));
  }

  scrollByItem(direction) {
    const firstItem = this.container.querySelector('.prod-opt-value__item');
    if (!firstItem) return;
    const scrollAmount =
      (firstItem.offsetWidth +
        parseInt(getComputedStyle(firstItem).marginRight || 0)) * 4;
    this.container.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
  }


  updateUI() {
    const scrollLeft = this.container.scrollLeft;
    const maxScrollLeft = this.container.scrollWidth - this.container.clientWidth;
    const canScrollLeft = scrollLeft > 0;
    const canScrollRight = scrollLeft < maxScrollLeft - 1;

    this.prevButton.disabled = !canScrollLeft;
    this.nextButton.disabled = !canScrollRight;

    this.shadowLeft.style.opacity = canScrollLeft ? '1' : '0';
    this.shadowRight.style.opacity = canScrollRight ? '1' : '0';
  }
}

customElements.define('option-element-slider', optionElementSlider);




class BundleTabs extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const heading = document.querySelector('[bucket-status-heading]');
    const text = document.querySelector('[bucket-status-text]');
    const grid = document.querySelector('.byb-grid');
    const quantityToggle = document.querySelector('[data-quantity-toggle]'); // target element to update

    this.querySelectorAll('.bundle--tab-btn')?.forEach(btn => {
      btn.addEventListener('click', () => {
        this.querySelectorAll('.bundle--tab-btn').forEach(d => d.classList.remove('active'));
        btn.classList.add('active');
        console.log(btn.dataset.quantity);
        
        if (heading) heading.textContent = btn.dataset.title || '';
        if (text) text.textContent = btn.dataset.text || '';
        if (grid) { grid.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        if (quantityToggle) { quantityToggle.dataset.quantityToggle = btn.dataset.quantity || ''; }
        const mainEle = this.parentElement.querySelector('build-your-bundle');
        if(mainEle){ mainEle.refreshPlaceholders();}
      });
    });
  }
}

customElements.define('bundle-tabs', BundleTabs);
